import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateEntityPeriodicityEnum } from '@zaoblako/shared/common/enums/template.entity.periodicity.enum';
import { PeriodicityPipe } from '@zaoblako/web/shared/pipes/periodicity.pipe';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  standalone: true,
  selector: 'crm-periodicity-single-select',
  templateUrl: 'periodicity-single-select.component.html',
  imports: [CommonModule, PeriodicityPipe, SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PeriodicitySingleSelectComponent {
  @Input() public periodicity: TemplateEntityPeriodicityEnum;
  @Output() public periodicityChange = new EventEmitter<TemplateEntityPeriodicityEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: string;

  public options = Object.values(TemplateEntityPeriodicityEnum);
}
